// @flow

import React from 'react';

const Mastercard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="20"
    viewBox="0 0 29 20">
    <g fill="none" fillRule="evenodd">
      <rect width="29" height="20" fill="#353A48" rx="2.707" />
      <path
        fill="#FF5E00"
        d="M14.31 6.32A5.7 5.7 0 0 0 10.648 5C7.528 5 5 7.472 5 10.522c0 3.05 2.528 5.523 5.647 5.523a5.7 5.7 0 0 0 3.664-1.32 5.7 5.7 0 0 0 3.663 1.32c3.119 0 5.647-2.473 5.647-5.523S21.093 5 17.974 5a5.7 5.7 0 0 0-3.663 1.32z"
      />
      <path
        fill="#ED0006"
        d="M14.31 6.32A5.7 5.7 0 0 0 10.648 5C7.528 5 5 7.472 5 10.522c0 3.05 2.528 5.523 5.647 5.523a5.7 5.7 0 0 0 3.664-1.32 5.461 5.461 0 0 1-1.985-4.203c0-1.683.77-3.19 1.985-4.203z"
      />
      <path
        fill="#F9A000"
        d="M15 14.726a5.7 5.7 0 0 0 3.663 1.319c3.12 0 5.648-2.473 5.648-5.523S21.782 5 18.663 5A5.7 5.7 0 0 0 15 6.32a5.461 5.461 0 0 1 1.984 4.202c0 1.683-.77 3.19-1.984 4.204z"
      />
    </g>
  </svg>
);

export default Mastercard;



// WEBPACK FOOTER //
// ./src/assets/icons/card-mastercard-svg.js